import PropTypes from 'prop-types';
import './FilterLabelBox.scss';

export const FilterLabelBox = (props) => {
  const { text, disabled, onClickHandler, extendClass = '' } = props;
  const disabledClass = disabled ? 'disabled' : '';
  const classes = ['filter-label-box', disabledClass, extendClass].join(' ');

  return (
    <button
      className={classes}
      aria-disabled={disabled}
      disabled={disabled}
      type="button"
      data-testid="filter-label"
      onClick={onClickHandler}
    >
      {text}
      <span className="icon" data-testid="close-icon">
        ×
      </span>
    </button>
  );
};

FilterLabelBox.propTypes = {
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onClickHandler: PropTypes.func,
  extendClass: PropTypes.string,
};
